import { InjectionToken } from '@angular/core';

/** Curated role, as far as a position/assignment palette needs it. */
export interface AssignableRole {
  id: string;
  assignableToPositions: boolean;
}

/**
 * Minimal interface for listing curated (`assignableToPositions`) roles.
 * Implemented by `RolesManagementService` from `@zag/auth/ui`.
 *
 * Same rationale as {@link FieldPermissionChecker}: buildable, ng-packagr'd
 * domain libraries (e.g. `@zag/timetracking/ui`'s org-chart editor, F20
 * org-chart-position-editor Story 5) cannot resolve a direct source-level
 * import of the non-buildable `@zag/auth/ui`. The token lives in `@zag/ui`
 * (not the consuming domain lib) so app-level route providers can bind it
 * without eagerly pulling a lazy-loaded domain module into the initial
 * bundle just to reach the token.
 *
 * @example
 * // In app bootstrap / route providers:
 * { provide: ASSIGNABLE_ROLES_SOURCE, useExisting: RolesManagementService }
 *
 * // In a library component:
 * private readonly assignableRolesSource = inject(ASSIGNABLE_ROLES_SOURCE);
 */
export interface AssignableRolesSource {
  roles(): AssignableRole[];
}

export const ASSIGNABLE_ROLES_SOURCE = new InjectionToken<AssignableRolesSource>('ASSIGNABLE_ROLES_SOURCE');
